import clsx from 'clsx';
import { cardLink } from './cards.css';

export const CardLink = ({
  children,
  className,
  noUnderline = false,
  ...props
}: React.ComponentProps<'a'> & { noUnderline?: boolean }) => {
  return (
    <a
      // intentionally removing it from focus flow. It should not get inside card
      tabIndex={-1}
      data-no-underline={noUnderline ? '' : undefined}
      className={clsx(cardLink, className)}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </a>
  );
};
